module.exports = __webpack_public_path__ + "img/AOGS2025 WEB DESIGN-03.888e6fbe.png";